import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    const run = async () => {
      try {
        const { data } = await api.post("/auth/session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/account", { replace: true, state: { user: data } });
      } catch {
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/sign-in", { replace: true });
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-cream">
      <p className="font-heading text-sm font-semibold text-coralInk">Signing you in…</p>
    </div>
  );
}
